import canClockSegmentEntry from '@/mixins/clocking/individual/canClockSegmentEntry';
import constants from '@/constants';

export default {
  mixins: [canClockSegmentEntry],

  methods: {
    createSegmentClockIn(
      timePair,
      assignmentId = null,
      pairType,
      successCallBack,
      lastly = () => {},
      timeZoneOffset = null,
      locationRequired = false,
      errorResetCallback = () => {},
    ) {
      this.getBaseTimeEntryRequest(
        constants.EntryType.CLOCK_IN,
        timeZoneOffset,
        locationRequired,
        assignmentId,
        null,
        (timeEntryRequest) => {
          timeEntryRequest.pairType = pairType;
          timeEntryRequest.shiftTimePairId = timePair.id;

          this.postSegmentTimeEntry(timeEntryRequest, successCallBack, lastly, errorResetCallback);
        },
        lastly,
      );
    },
  },
};
